// chat powered by Endear. See https://docs.endearhq.com/docs/getting-started
import { getCSQGlobal } from './analytics.service';
import { toggleAccessibleIcon } from './accessibility.service';
import { getElementOrParentByClassName, waitForTruthyVal, addUrlProtocol } from '../helpers/utils';
export const SESSION_STORAGE_CS_CHAT_KEY = "csChatInitiated";
export function setupChatApp() {
    if (window.UNTUCKitConfig.thirdPartyToggles.endear && !window.UNTUCKitConfig.isApp) {
        console.log("setting up endear sales chat app");
        document.body.classList.remove('hide-chat');
        waitForTruthyVal(() => typeof window.endear === 'function').then(() => {
            console.log("endear global object found. adding event listeners");
            document.addEventListener("click", function (e) {
                const target = e.target;
                // use open_chat; open_hero_chat is legacy
                if (getElementOrParentByClassName(target, 'open_chat') || getElementOrParentByClassName(target, 'open_hero_chat')) {
                    e.preventDefault();
                    window.endear("open");
                }
            });
            window.endear("onReady", () => {
                if (window.UNTUCKitConfig.chat.showAssociateAvailableIndicator) {
                    const chatIndicatorEl = document.createElement('span');
                    const status = window.endear.initialState.availability === 'available_for_chat' ? 'available' : 'unavailable';
                    chatIndicatorEl.classList.add('chat-indicator', `chat-indicator--${status}`);
                    chatIndicatorEl.ariaLabel = `Associates are currently ${status}`;
                    Array.from(document.querySelectorAll(".open_chat")).forEach(el => {
                        el.append(chatIndicatorEl.cloneNode());
                    });
                }
            });
            window.endear("onOpen", function () {
                console.log("Endear chat opened");
                toggleAccessibleIcon('hide');
            });
            window.endear("onMessage", (e) => {
                const { conversationId, direction, senderId } = e.detail;
                console.log("A endear message was sent or received", { conversationId, direction, senderId });
                switch (direction) {
                    case 'INBOUND':
                        break;
                    case 'OUTBOUND':
                        break;
                    default:
                        console.log(`Conversation ${conversationId} has an unknown direction: ${direction}`);
                }
            });
            window.endear("onConversation", (e) => {
                const { conversationId, browserContextId, status } = e.detail;
                console.log("A conversation was updated", { conversationId, browserContextId, status });
                switch (status) {
                    case 'OPEN':
                        break;
                    case 'CLOSED':
                        break;
                    case 'BLOCKED':
                        console.log(`Conversation ${conversationId} is blocked.`);
                        break;
                    default:
                        console.log(`Conversation ${conversationId} has an unknown status: ${status}`);
                }
            });
            window.endear("onClose", function () {
                console.log("Endear chat closed");
                toggleAccessibleIcon('show');
            });
            window.endear("onConversationClaimed", (e) => {
                console.log("Endear chat onConversationClaimed", e.detail);
                window.endear("setCustomAttribute", {
                    type: "TEXT",
                    key: "Last Chat Claimed",
                    value: new Date().toString()
                });
                getCSQGlobal().push(["replay:link:generate", { withTimestamp: false }, (context) => {
                        const { replayLink } = context;
                        if (replayLink) {
                            window.endear("setCustomAttribute", {
                                type: "URL",
                                key: "contentsquare-session-replay",
                                value: {
                                    name: "Contentsquare Session Replay",
                                    url: addUrlProtocol(replayLink)
                                }
                            });
                        }
                    }]);
            });
        }).catch(() => console.error("Endear sales chat toggled on, but instance not available."));
    }
}
